export const locationsMap = {
  ACTIVITIES: 'Activities',
  COMMERCIALS: 'Commercial',
  CULTURES: 'Cultural venues',
  FOODS: 'Food, restaurant and bars',
  NATURES: 'Nature and views',
  TOURISTS: 'Tourists sights and landmarks',
};

export const facilitiesMap = {
  NOT_AVAILABLE: 'N/A',
};

export const facilitiesInterval = {
  'per/h': '/ h',
  'per/day': '/ day',
};

export const payedStatus = 'PAID';

export const reviewRatingsMap = {
  comfortAndServiceComment: 'Comfort & Service',
  atmosphereAndDesignComment: 'Atmosphere & Design',
  locationAndConvenienceComment: 'Location & Convenience',
  facilitiesAndActivitiesComment: 'Facilities & Activities',
  foodAndBeveragesComment: 'Food & Beverages',
  environmentalAndSocialComment: 'Environmental & Social',
};
